import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'

export const SearchWelcome = () => {
  return (
    <div className="text-center py-12">
      <MagnifyingGlassIcon className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-2 text-lg font-semibold text-gray-900">
        Search our blog
      </h3>
      <p className="mt-1 text-gray-500">
        Enter a search term above to explore our blog posts
      </p>
    </div>
  )
}

